import { useState } from 'react';

import {
    DropdownArrow,
    RenderResourceSubmenu,
    type ResourceItemDTO,
    CollapsibleBox,
} from '@/src/ui';
import './css/ResourceBoxes.css';

function ResourceBoxInner({
    id,
    item,
    namespace,
    grade,
}: {
    id: string;
    item: ResourceItemDTO;
    namespace: string;
    grade?: string;
}) {
    const [isActive, setIsActive] = useState(false);
    const arrowRotation: 'up' | 'down' = isActive ? 'up' : 'down';

    const hasRenderableSubitems = item.collapsible && item.subitems && item.subitems.length > 0;
    if (hasRenderableSubitems) {
        return (
            <div
                className={`${namespace}-box-inner ${grade ? `pd-G${grade}-secondary` : 'pd-secondary'} background`}
            >
                <div className="resources-item cursor-pointer">
                    <div
                        id={id}
                        className={`box-item-button pd-dark text${isActive ? ' active' : ''}`}
                        onClick={() => {
                            if (item.collapsible) setIsActive(!isActive);
                        }}
                    >
                        {item.text}
                        {hasRenderableSubitems ? (
                            <DropdownArrow id={id} rotate={arrowRotation} color="black" />
                        ) : null}
                    </div>
                    <CollapsibleBox isOpen={isActive}>
                        {item.subitems!.map((subitem, index) => (
                            <RenderResourceSubmenu
                                key={`${item.id}-subitem-${index}-dropdown`}
                                namespace={namespace}
                                data={subitem}
                                classNames={`${namespace}-sub-resources-item resources-resources-subcategories pd-dark text`}
                            />
                        ))}
                    </CollapsibleBox>
                </div>
            </div>
        );
    }

    return (
        <div
            className={`${namespace}-box-inner ${grade ? `pd-G${grade}-secondary` : 'pd-secondary'} background`}
        >
            <div className="resources-item cursor-pointer">
                <a
                    id={id}
                    className={`box-item-button pd-dark text${isActive ? ' active' : ''}`}
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                        if (item.collapsible) setIsActive(!isActive);
                    }}
                >
                    {item.text}
                </a>
            </div>
        </div>
    );
}

export default ResourceBoxInner;
